import i18next from 'i18next';
import React from 'react';

import { getTheme } from '@commons/utils/theme';

import { getStatusColor, STATUS_GROUPS } from '../constants';

import {
  LegendDescription,
  LegendDot,
  LegendLabel,
  LegendList,
  LegendRow,
  LegendTextContainer,
} from './styledComponents';

const theme = getTheme();

const StatusLegendModal = () => (
  <LegendList>
    {STATUS_GROUPS.map(({ id, statuses, labelKey, descriptionKey }) => (
      <LegendRow key={id}>
        <LegendDot color={getStatusColor(statuses[0])} />
        <LegendTextContainer>
          <LegendLabel color={theme.colors.greys.darkest} font={theme.fonts.textSmallBold}>
            {i18next.t(labelKey)}
          </LegendLabel>
          <LegendDescription color={theme.colors.greys.dark} font={theme.fonts.textSmall}>
            {i18next.t(descriptionKey)}
          </LegendDescription>
        </LegendTextContainer>
      </LegendRow>
    ))}
  </LegendList>
);

export default StatusLegendModal;
